export default __webpack_public_path__ + "static/media/shibin.29028bc1.jpg";